import { ENDPOINTS } from '@/settings/api-settings';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import { isEqual } from 'lodash';
import { from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from './api';

interface ITokenData {
  sub: string;
  exp: any;
}

var keepInStorage = ['redirect', 'redirectEmp', 'redirectOrigin', 'ruf', 'ru'];


export function clearLocalStorage() {
  for (var i=0; i< localStorage.length; i++) {
    var key = localStorage.key(i);
    if (keepInStorage.find(k => k == key)) {
      continue;
    }
    localStorage.removeItem(key);
    i--;
  }
}
export function clearSessionStorage() {
  for (var i=0; i< sessionStorage.length; i++) {
    var key = sessionStorage.key(i);
    if (keepInStorage.find(k => k == key)) {
      continue;
    }
    sessionStorage.removeItem(key);
    i--;
  }
}


function getToken(): string {
  const authUser = window.sessionStorage.getItem('authToken');
  return authUser;
}

function getTokenValues(): ITokenData {
  const base64 = getToken().split('.')[1];
  const words = Base64.parse(base64);
  return JSON.parse(Utf8.stringify(words)) as ITokenData;
}

function setToken(token: string): void {
  sessionStorage.setItem('authToken', token);
  localStorage.removeItem('authToken');
}

function getLocalClient() {
  return JSON.parse(sessionStorage.getItem('selectedClient'));
}

function getLocalBusinessUnit() {
  return JSON.parse(sessionStorage.getItem('selectedBusinessUnit'));
}

function getSelectedBusinessUnitFromLocal(): Observable<any> {
  return of(getLocalBusinessUnit()).pipe(map((data) => data));
}

function setSelectedBusinessUnitToLocal(businessUnit: any): any {
  sessionStorage.setItem('selectedBusinessUnit', JSON.stringify(businessUnit));
  sessionStorage.removeItem('selectedClient');
  localStorage.removeItem('selectedBusinessUnit');
}

function getSelectedClientFromLocal(): Observable<any> {
  return of(getLocalClient()).pipe(map((data) => data));
}

function setSelectedClientToLocal(clientUnit: any): any {
  sessionStorage.setItem('selectedClient', JSON.stringify(clientUnit));
  localStorage.removeItem('selectedClient');
}

function updateUserPermissionsFromLocal(
  permissions: string[],
): Observable<any> {
  sessionStorage.setItem('permissions', JSON.stringify(permissions));
  localStorage.removeItem('permissions');
  return of(true);
}

function getUserPermissionsFromLocal(): string[] {
  const permissions = JSON.parse(sessionStorage.getItem('permissions'));
  if (!!permissions) {
    return permissions;
  }
  return [];
}

function getCurrentUserPermission(): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.USER_SESSION_DATA)).pipe(
    map((r: any) => {
      if (!r.data || !r.data.permissoes || !r.data.permissoes.length) {
        return [];
      }

      if (r.data.idEmpresa && r.data.unidadesEmpresariais && r.data.unidadesEmpresariais.length) {
        if (getLocalBusinessUnit() && getLocalBusinessUnit().id && getLocalBusinessUnit().id != r.data.idEmpresa) {
          setSelectedBusinessUnitToLocal(r.data.unidadesEmpresariais.filter(f => f.id == r.data.idEmpresa)[0]);
        }
      }

      if (r.data.idUnidadeCliente && r.data.unidadesCliente && r.data.unidadesCliente.length) {
        if (getLocalClient() && getLocalClient().id && getLocalClient().id != r.data.idUnidadeCliente) {
          setSelectedClientToLocal(r.data.unidadesCliente.filter(f => f.id == r.data.idUnidadeCliente)[0]);
        }
      }

      return r.data.permissoes;
    }),
  );
}

function setLocalUser(user): void {
  sessionStorage.setItem('user', JSON.stringify(user));
  localStorage.removeItem('user');
  // sessionStorage.removeItem('selectedClient');
  // sessionStorage.removeItem('selectedBusinessUnit');
}

function getLocalUser(): Observable<any> {
  return of(getLocalUserObj()).pipe(map((data) => data));
}

export function getLocalUserObj() {
  return JSON.parse(sessionStorage.getItem('user'));
}

function getSessionData(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.USER_SESSION_DATA)).pipe(
    map((r: any) => {
      return {
        ...r.data,
        permissoes: r.data.permissoes,
      };
    }),
  );
}

function checkToken(): (reloadHandler: any) => void {
  const currentToken = getToken();
  const currentClient = getLocalClient();
  return (reloadHandler) => {
    const newToken = getToken();
    const newClient = getLocalClient();
    if (currentToken !== newToken || !isEqual(currentClient, newClient)) {
      reloadHandler();
    }
  };
}

export function setRedirectAfterLogin(redirect: string) {
  sessionStorage.setItem('redirect', redirect);
}

export function getRedirectAfterLogin(): string {
  return sessionStorage.getItem('redirect');
}

export function removeRedirectAfterLogin() {
  sessionStorage.removeItem('redirect');
}

export function setRedirectEmpresaAfterLogin(emp: string) {
  sessionStorage.setItem('redirectEmp', emp);
}

export function getRedirectEmpresaAfterLogin(): string {
  return sessionStorage.getItem('redirectEmp');
}

export function removeRedirectEmpresaAfterLogin() {
  sessionStorage.removeItem('redirectEmp');
}

export function setRedirectLinkOrigin(or: string) {
  sessionStorage.setItem('redirectOrigin', or.toUpperCase());
}

export function getRedirectLinkOriginAndRemove(): string {
  let val = sessionStorage.getItem('redirectOrigin')
  sessionStorage.removeItem('redirectOrigin');
  return val;
}

export function setPopupLoginShown(value: boolean) {
  sessionStorage.setItem('popupLoginShown', String(value));
}

export function isPopupLoginShown(): boolean {
  let val = sessionStorage.getItem('popupLoginShown');
  return val != null && val == 'true';
}

export function removePopupLoginShown(): void {
  sessionStorage.removeItem('popupLoginShown');
}

export function setRememberOnOff(value: boolean) {
  localStorage.setItem('ruf', String(value));
}

export function isRememberOn(): boolean  {
  let val = localStorage.getItem('ruf');
  return val == null || val == 'true';
}

export function addLoginRemember(value:string) {
  let json = new Array<any>();
  let item = localStorage.getItem('ru');
  if (item) {
    json = JSON.parse(item) as Array<any>;
  }
  if (json.find(u => u.value == value)) {
    return;
  }
  json.push({
    label: maskLoginValue(value), 
    value: value
  });
  localStorage.setItem('ru', JSON.stringify(json));
}

export function removeLoginRemember(value:string): Array<any>  {
  let json = new Array<any>();
  let item = localStorage.getItem('ru');
  if (item) {
    json = JSON.parse(item) as Array<any>;
  }
  json = json.filter(u => u.value != value)
  localStorage.setItem('ru', JSON.stringify(json));
  return json;
}

function maskLoginValue(value:string) {
  let masked = "";
  for (let i=0; i< value.length; i++) {
    if (value.length > 5 && i > 2 && i< value.length -2) {
      masked += "*"
    } else {
      masked += value.charAt(i);
    }
  }
  return masked;
}

export function getLoginsRemember(): Array<any> {
  let item = localStorage.getItem('ru');
  if (item) {
    return JSON.parse(item) as Array<any>;
  }
  return [];
}

export function setObjSessionStorageUser(key: string, obj: any, keep: boolean = false) {
  var userKey = buildUserSessionKey(key);
  sessionStorage.setItem(userKey, JSON.stringify(obj)); 
  if (keep) {
    keepInStorage.push(userKey);
  }
}

export function getObjSessionStorageUser(key: string): any {
  let obj = sessionStorage.getItem(buildUserSessionKey(key)); 
  if (!obj) {
    return null;
  }
  return JSON.parse(obj);
}

export function setObjLocalStorageUser(key: string, obj: any, keep: boolean = false) {
  var userKey = buildUserSessionKey(key);
  localStorage.setItem(userKey, JSON.stringify(obj));
  if (keep) {
    keepInStorage.push(userKey);
  } 
}

export function getObjLocalStorageUser(key: string): any {
  let obj = localStorage.getItem(buildUserSessionKey(key)); 
  if (!obj) {
    return null;
  }
  return JSON.parse(obj);
}

function buildUserSessionKey(key) {
  return key + "_" + getLocalUserObj().idLogin;
}

export {
  getToken,
  setToken,
  getTokenValues,
  getSelectedBusinessUnitFromLocal,
  setSelectedBusinessUnitToLocal,
  getSelectedClientFromLocal,
  setSelectedClientToLocal,
  getUserPermissionsFromLocal,
  updateUserPermissionsFromLocal,
  getCurrentUserPermission,
  getSessionData,
  setLocalUser,
  getLocalUser,
  checkToken,
  getLocalClient,
  getLocalBusinessUnit,
};

